/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { Box, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import CoursesViewStyles from './CoursesViewStyles';
import CourseMenuView from './CourseMenu/CourseMenuView';
import { observer } from 'mobx-react';
import { Emoji } from 'emoji-mart';
import { format } from 'date-fns';
import { Course } from '../../../../types/course/Course';
import { Pages } from '../../../../navigation/Pages';
import { ViewModel } from '../../../../core/viewmodel/ViewModel';
import { useViewModel } from '../../../../hooks/useViewModel';
import { useRouteMatch } from 'react-router-dom';

interface Props {
	course: Course;
}

const CoursesView = observer((props: Props) => {
	const viewModel: ViewModel = useViewModel(ViewModel);
	const classes = CoursesViewStyles();
	const { course } = props;
	const { url } = useRouteMatch();

	return (
		<Paper className={classes.paper}>
			<CourseMenuView courseId={course.courseId} />
			<Box
				className={classes.paperBox}
				onClick={() => {
					viewModel.navigateTo(`${url}/${course.courseId}${Pages.ENTRIES}`);
				}}>
				<Box className={classes.courseIcon}>{course.emoji && <Emoji emoji={course.emoji} size={22} />}</Box>
				<Box className={classes.courseText}>
					<Typography variant={'h2'}>{course.name}</Typography>
					<Typography variant={'body1'} component={'p'}>
						<FormattedMessage id='courses.courseMember' /> {course.courseMember}
					</Typography>
				</Box>
				<Typography className={classes.courseDate} variant={'body1'} component={'p'}>
					<FormattedMessage id='courses.date' /> {format(new Date(course.startDate as Date), 'dd.MM.YYY')}
				</Typography>
			</Box>
		</Paper>
	);
});

export default CoursesView;
